import { spinSettings } from 'settings/custom/reels'

export default class SpinModel {
  constructor() {
    this._data = {
      lines: 0,
      current: '',
      actions: '',
      mathType: '',

      reelItems: {},

      slideItems: {},

      explosionItems: {},

      chance: [],

      buy: [],

      matrix: [],
      list: {},

      reels: [],
      fsReels: [],
      bonusReels: [],
      freebets: {},

      reelSymbols: [],

      paths: [],
      width: 0,
      height: 0,

      respin: [],
      respinTotalWin: 0,

      action: '',
    }
  }

  get() {
    return this._data
  }

  set(value) {

    this._data.action = value.context.actions[0]
    this._data.actions = value.context.actions
    this._data.current = value.context.current
    this._data.matrix = value.context.matrix //[['D', 'E', 'G'], ['F', 'G', 'D'], ['I', '2', 'J'], ['B', 'G', 'H'], ['C', 'J', 'E']]
    this._data.list = this._data.matrix.reduce((acc, reel, rid) => {
      reel.forEach((sym, sid) => acc[`${rid}${sid}`] = sym)
      return acc
    }, {})
    this.makeChance(value.context.matrix)
    this.detectRespin(value.context.matrix)
  }

  makeChance(value) {
    this._data.chance = value
      .map((reel) => reel.includes('1'))
      .map((val, idx, arr) => arr.slice(0, idx).reduce((acc, v) => acc + v, 0))
      .map((sum) => sum >= 2)
  }

  detectRespin(value) {
    this._data.respin = []
    if (this._data.action === 'respin' || this._data.action === 'fsRespin') {
      if(spinSettings.respin.infinity){

        value.forEach((item, i) => {
          this._data.respin.push(i)
        })
      }
      else{
        value.forEach((item, i) => item.includes('2') && this._data.respin.push(i))
      }

    }
  }

  setSymbol(reel, pos, item) {
    this._data.reelItems[`${reel},${pos}`] = item
  }

  setSlideSymbol(reel, pos, item) {
    this._data.slideItems[`${reel},${pos}`] = item
  }
  setExplosionItemsSymbol(reel, pos, item) {
    this._data.explosionItems[`${reel},${pos}`] = item
  }

  setSettings(value) {

    this._data.mathType = value.type

    this._data.lines = Object.keys(value.lines).length
    const symbols = {}
    // todo Попросить Алину что бы все символы приходили в paytable, Убрать  костиль.
    if (typeof(value.reelsets) === 'undefined' || value.gameId === 14 || value.gameId === 24 || value.gameId === 23 || value.gameId === 78 || value.gameId === 56 || value.gameId === 165 || value.gameId === 207 || value.gameId === 138 || value.gameId === 147 || value.gameId === 142 || value.gameId === 151) {
      this._data.reels = value.reels
      value.reels.forEach((reel) => reel.forEach((sym) => symbols[sym] = true))
      this._data.reelSymbols = Object.keys(symbols).sort()
    }
    else {
      this._data.reels = value.reelsets.spin
      value.reelsets.spin.forEach((reel) => reel.forEach((sym) => symbols[sym] = true))
      this._data.reelSymbols = Object.keys(value.paytable).sort()
    }
    this._data.fsReels = !value.fsReels ? [] : value.fsReels
    this._data.bonusReels = !value.reelsets ? [] : value.reelsets
    this._data.buy = value.buy ? value.buy : []

    this._data.fsReels.forEach((reel) => reel.forEach((sym) => symbols[sym] = true))
    this._data.width = value.width
    this._data.height = value.height
    this._data.paths = value.lines
  }
}
